// Resolves the `/rules/tickets/<ref>` deep links services/rules sends: rules
// notification mails carry the display ref (R-014608 / F-001970,
// trackerjobs.ticketURL) and the GitLab mirror carries the numeric ticket id
// (gitlabsync). Links already sent keep working; the link format is not ours
// to change.

export type TicketLinkTarget =
  | { name: 'rules-question-detail' | 'rules-feedback-detail'; params: { ref: string } }
  | { id: string }
  | null

export function ticketLinkTarget(ref: string): TicketLinkTarget {
  if (/^R-\d+$/i.test(ref))
    return { name: 'rules-question-detail', params: { ref: ref.toUpperCase() } }
  if (/^F-\d+$/i.test(ref))
    return { name: 'rules-feedback-detail', params: { ref: ref.toUpperCase() } }
  if (/^\d+$/.test(ref)) return { id: ref }
  return null
}
